import request from '@/utils/request'

export function getUserInfo() {
    return request({
        url: `api/personalUser/byId`,
        // url: "api/meeting/searchMeeting",
        method: 'get',
        // data
    })
}